import { UI_PROGRAM_SETTINGS_ACTION_TYPE } from 'store/system/actions';

const initialState = {};

const uiProgramSettingsReducer = (state = initialState, { type, payload }) => {
  switch (type) {
    case UI_PROGRAM_SETTINGS_ACTION_TYPE.GET_SETTINGS:
    case UI_PROGRAM_SETTINGS_ACTION_TYPE.EDIT_SETTINGS:
      return payload;

    default:
      return state;
  }
};

export default uiProgramSettingsReducer;
